export const BILLION = 1e9
export const MILLION = 1e6
export const THOUSAND = 1e3
export const TWO_THOUSAND = 2000
export const HUNDRED = 100
export const TWO_HUNDRED = 200
export const THREE_HUNDRED = 300
export const FIVE_HUNDRED = 500
export const SIX_HUNDRED = 600
export const EIGHT_HUNDARD_TWENTY = 820
export const HUNDRED_THOUSAND = 100000

export const ZERO = 0
export const ONE = 1
export const TWO = 2
export const THREE = 3
export const FOUR = 4
export const FIVE = 5
export const NINE = 9
export const TEN = 10
export const ELEVEN = 11

export const FORTY_FIVE = 45
export const SIXTY_SIX = 66
export const SIXTY_FIVE = 65
export const THIRTY_THREE = 33
export const TWENTY_FIVE = 25
export const TWENTY = 20
export const TWENTY_NINE = 29
export const THIRTY_ONE = 31
export const THIRTY_TWO = 32
export const FOURTY = 40
export const SIXTY = 60
export const EIGHTY = 80
export const FIFTY = 50
export const SEVENTY_FIVE = 75
